/**
 * 手机号地区选择
 * */
import React, { PureComponent } from 'react';
import { Input } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import Util from '../../script/util';
import './nationCode.scss';

export default class NationCode extends PureComponent {
  state = {
    nationCodeArr: [],
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot) {
      this.setState({ nationCodeArr: this.getNationCode() });
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    return prevProps.visible !== this.props.visible && !!this.props.visible;
  }

  getNationCode = () => {
    let hotArea = [
      { firstWord: '热门' },
      // {cn_name: "中国大陆", hk_name: "中國大陸", country_name: "China", code: "86"},
      {
        cn_name: '中国澳门',
        hk_name: '中國澳門',
        country_name: 'Macau',
        code: '853',
      },
      {
        cn_name: '中国香港',
        hk_name: '中國香港',
        country_name: 'Hong Kong',
        code: '852',
      },
      {
        cn_name: '中国台湾',
        hk_name: '中國臺灣',
        country_name: 'Taiwan',
        code: '886',
      },
    ];
    let allNationCode = Util.getAllNationCode();
    allNationCode = hotArea.concat(allNationCode);
    return allNationCode;
  };
  searchNation = (e) => {
    let val = e.currentTarget.value.toLowerCase();
    let searchList = [];
    let searchTarget = this.getNationCode();
    searchTarget.map((item, index) => {
      if (
        !item.firstWord &&
        (item.cn_name.indexOf(val) > -1 ||
          item.country_name.toLowerCase().indexOf(val) > -1)
      ) {
        searchList.push(item);
      }
      return null;
    });
    if (val && searchList.length > 0) {
      this.setState({
        nationCodeArr: searchList,
      });
    } else {
      this.setState({
        nationCodeArr: searchTarget,
      });
    }
  };

  render() {
    const { className, base, visible, selNation } = this.props;
    const { rootConfig } = base;
    const { nationCodeArr } = this.state;
    return visible ? (
      <div className={`nation-code-wrapper ${className}`}>
        <Input
          placeholder="搜索您的国家和地区"
          autoComplete="off"
          onChange={this.searchNation}
          prefix={<FileSearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        />
        <div className="nation-list">
          {nationCodeArr.map((item, index) => (
            <div className="word-item" key={index}>
              {item.firstWord ? (
                <span className="first-word">{item.firstWord}</span>
              ) : (
                <div
                  onClick={selNation.bind(this, item)}
                  className="nation-item"
                >
                  {rootConfig.lang == 'zh_CN' && <span>{item.cn_name}</span>}
                  {rootConfig.lang == 'zh_TW' && <span>{item.hk_name}</span>}
                  {rootConfig.lang == 'en_US' && (
                    <span>{item.country_name}</span>
                  )}
                  <span>+{item.code}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    ) : null;
  }
}
